import dayjs from 'dayjs';
import { EndPreset, PassWindow, StartMode } from './pass-window';

type Translate = (o: { key: string; extra?: Record<string, unknown> }) => string;

// Map explícito en vez de dayjs.locale('es'): no depende de que el archivo de
// locale entre en el bundle y mantiene los tests deterministas.
const DOW = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];

export function formatDayLabel(date: string): string {
    const d = dayjs(date);
    return `${DOW[d.day()]} ${d.format('D/M')}`;
}

// Con inicio "ahora" el día de inicio es hoy, así que "Hoy"/"Mañana" son literales.
// Con inicio agendado a otra fecha serían falsos: ahí van etiquetas de duración.
export function presetKey(preset: Exclude<EndPreset, 'exact'>, startMode: StartMode): string {
    return startMode === 'now' ? `visit-pass.expire-${preset}` : `visit-pass.expire-${preset}-from`;
}

export interface SummaryInput {
    window: PassWindow;
    startMode: StartMode;
    endPreset: EndPreset;
    startTime: string;
    endTime: string;
    maxUses?: number;
    translate: Translate;
}

export function buildSummary(input: SummaryInput): string {
    const { window: w, startMode, endPreset, startTime, endTime, maxUses, translate } = input;

    const isDominantCase = startMode === 'now' && endPreset === 'p1';
    const base = isDominantCase
        ? translate({ key: 'visit-pass.summary-today' })
        : translate({
              key: 'visit-pass.summary-range',
              extra: {
                  // Literal y no una key: es una palabra dentro de una frase ya
                  // traducida, y meterla por i18n obligaría a traducir media oración.
                  from: formatDayLabel(w.startDate),
                  fromTime: startMode === 'now' ? 'ahora' : startTime,
                  to: formatDayLabel(w.endDate),
                  toTime: endPreset === 'exact' ? endTime : '23:59',
              },
          });

    if (maxUses === undefined) {
        return base;
    }
    const uses = translate({
        key: maxUses === 1 ? 'visit-pass.uses-count' : 'visit-pass.uses-count-plural',
        extra: { count: maxUses },
    });
    return `${base} · ${uses}`;
}
